import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { router } from './router/router';
import { RoutesTypes } from './router/routerTypes';
import { ConfigProvider } from 'antd';
import { BackofficeProvider } from './backoffice/useBackoffice';
import { ALIGN_BRAND_BLACK } from './styles/colors';

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID as string}
      authorizationParams={{
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: 'openid profile email',
        redirect_uri: window.location.origin + '/' + RoutesTypes.Customers,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: ALIGN_BRAND_BLACK.CharcoalBrown,
            },
          }}
        >
          <BackofficeProvider>
            <RouterProvider router={router} />
          </BackofficeProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </Auth0Provider>
  </React.StrictMode>
);
